import { useEffect, useState } from 'react'
import MainLoader from "./components/common/MainLoader";
import Cookie from './utils/cookie.util.js';
import axios from 'axios';
import { useStore } from './components/providers/StoreContext.jsx';
import MESSAGE from './constants/message.constant.js';
import toasty from './utils/toasty.util.jsx';
import { getIframeToken } from './utils/iframeAuth.util.js';


const AuthenticateHandler = ({ children }) => {

    const [isSessionLoading, setIsSessionLoading] = useState(true);
    const { updateStore } = useStore();

    useEffect(() => {
        getUserSession();
    }, []);

    const getUserSession = async () => {
        try {
            let alertsComplianceObj = null;
            setIsSessionLoading(true);
            const token = await Cookie.get("x-token") || getIframeToken();
            if (token) {
                axios.defaults.headers.Authorization = token;
                axios.defaults.headers['x-client-route'] = window.location.pathname;
                const response = await axios.post(`api/common/session`);
                console.log("🚀 ~ getUserSession ~ response:", response)
                if (response?.data?.session?.clientId) {
                    alertsComplianceObj = await fetchAlertsCompliances(response.data.session.clientId);
                }
                updateStore({ user: response.data.session, isAuthenticated: true, alertsCompliance: alertsComplianceObj || null });
            }
        } catch (error) {
            toasty.error(error?.response?.data?.message || MESSAGE.ERROR_AFTER_HOUR)
        }
        finally {
            setIsSessionLoading(false);
        }
    };

    const fetchAlertsCompliances = async (clientId) => {
        try {
            const { data } = await axios.get(`/api/client/alert-compliance-integrations?clientId=${clientId}`);
            console.log("🚀 ~ fetchAlertsCompliances ~ response:", data);
            if (data.response) {
                return data.response;
            }
        } catch (error) {
            toasty.error(error?.response?.data?.message || MESSAGE.ERROR_AFTER_HOUR)
        }
    }


    return (
        <>
            {isSessionLoading ? <MainLoader /> : children}
        </>
    );
};

export default AuthenticateHandler;